// extracted by mini-css-extract-plugin
export default {"formlabel":"MessageExtraInfo_formlabel__pYUIE","formctrl":"MessageExtraInfo_formctrl__adcdS","forminput":"MessageExtraInfo_forminput__3ps82"};